"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameConstants_1 = require("../../GameConstants");
var GameVars_1 = require("../../GameVars");
var BoardManager_1 = require("../BoardManager");
var Pile = /** @class */ (function (_super) {
    __extends(Pile, _super);
    function Pile(game, x, y, column) {
        var _this = _super.call(this, game, x, y, "texture_atlas_1", "empty-pile") || this;
        _this.foundation = false;
        _this.column = column;
        _this.piledCards = [];
        _this.anchor.set(.5);
        _this.scale.y = GameVars_1.GameVars.scaleY;
        _this.game.physics.enable(_this, Phaser.Physics.ARCADE, GameConstants_1.GameConstants.SHOW_BOUNDING_AREAS);
        return _this;
    }
    Pile.prototype.addCard = function (card) {
        if (card !== this.piledCards[this.piledCards.length - 1]) {
            this.piledCards.push(card);
            // mas las que llevaba a rastras
            // no se pq pero concat no funciona
            for (var i = 0; i < card.attachedCards.length; i++) {
                this.piledCards.push(card.attachedCards[i]);
            }
        }
    };
    Pile.prototype.removeCard = function (card) {
        var i = this.piledCards.indexOf(card);
        if (i + 1 < this.piledCards.length && i > -1) {
            card.attachedCards = this.piledCards.slice(i + 1);
        }
        if (i > -1) {
            this.piledCards.length = i;
        }
    };
    Pile.prototype.recalculatePositions = function () {
        var y = this.y;
        for (var i = 0; i < this.piledCards.length; i++) {
            if (this.piledCards[i].y !== y) {
                this.game.add.tween(this.piledCards[i])
                    .to({ y: y }, 200, Phaser.Easing.Cubic.Out, true);
            }
            var num = BoardManager_1.BoardManager.currentInstance.compressPositions(this);
            if (num > 0) {
                if (this.piledCards[i].turned) {
                    y += Pile.CARDS_OFFSET / (1 + (num * .1));
                }
                else {
                    y += Pile.CARDS_OFFSET / 2;
                }
            }
            else {
                if (this.piledCards[i].turned) {
                    y += Pile.CARDS_OFFSET;
                }
                else {
                    y += Pile.CARDS_OFFSET / 2;
                }
            }
        }
    };
    Pile.CARDS_OFFSET = 50;
    return Pile;
}(Phaser.Sprite));
exports.Pile = Pile;
